import React from 'react';
import { PhoneIcon, DropletIcon, FlameIcon, CloudLightningIcon, ClockIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { COMPANY } from '../lib/site';
import { MagneticButton } from '../components/fx/MagneticButton';
import { Reveal } from '../components/fx/Reveal';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ProcessSection } from '../components/sections/ProcessSection';
const emergencies = [{
  icon: DropletIcon,
  title: 'Water Damage',
  text: 'Burst pipes, flooding, and leaks — extracted and dried fast.'
}, {
  icon: FlameIcon,
  title: 'Fire & Smoke',
  text: 'Soot, smoke, and structural fire recovery around the clock.'
}, {
  icon: CloudLightningIcon,
  title: 'Storm Damage',
  text: 'Hurricane and storm response to secure and restore your home.'
}];
export function Emergency() {
  return <>
      <PageHero eyebrow="24/7 Emergency Restoration" title="When Disaster Strikes, We Answer." subtitle="Water, fire, or storm — our certified crews are on standby around the clock across Houston and surrounding areas." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Emergency'
    }]} data-id="element-431" data-mp="1o0yh6ivudum" />

      <section className="mx-auto max-w-4xl px-6" data-id="element-432" data-mp="2f4w3k27919kz">
        <Reveal data-id="element-433" data-mp="2tutz537id1k7">
          <a href={COMPANY.phoneHref} className="relative flex flex-col items-center gap-3 overflow-hidden rounded-[2.5rem] bg-fire px-8 py-12 text-center text-white shadow-fire sm:flex-row sm:justify-center sm:gap-6" data-cursor="button" data-id="element-434" data-mp="2tuagfka1a954">
            <span className="absolute inset-0 bg-crimson opacity-0 transition-opacity hover:opacity-100" data-id="element-435" data-mp="2xwozo5hm7awx" />
            <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white/20" data-id="element-436" data-mp="18h7g5265l1g8">
              <span className="absolute inset-0 rounded-full bg-white/30 animate-pulse-ring" data-id="element-437" data-mp="13jz29ds1fjks" />
              <PhoneIcon className="h-8 w-8" data-id="element-438" data-mp="33m70pa5p8sbc" />
            </span>
            <span className="relative" data-id="element-439" data-mp="38k06w3705mbm">
              <span className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-widest opacity-90 sm:justify-start" data-id="element-440" data-mp="38l1hy7o0q8tc">
                <ClockIcon className="h-4 w-4" data-id="element-441" data-mp="3hkycgpx3a1wb" /> Call Now — We Respond Fast
              </span>
              <span className="mt-1 block font-display text-3xl font-bold sm:text-4xl" data-id="element-442" data-mp="3hilp1x8kazbv">
                {COMPANY.phoneDisplay}
              </span>
            </span>
          </a>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-24" data-id="element-443" data-mp="4out89hlvdk">
        <SectionHeading eyebrow="We Handle" title="Emergencies We Respond To" data-id="element-444" data-mp="58eatescrtp" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-445" data-mp="5288o729w64z">
          {emergencies.map((e, i) => <Reveal key={e.title} delay={i * 0.1} data-id="element-446" data-mp="96fyy8odpu5b" data-mpi={i}>
              <div className="gradient-border h-full rounded-4xl p-8 shadow-glass" data-id="element-447" data-mp="e47rn4wulkak">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-fire/10 text-fire" data-id="element-448" data-mp="e1vbmxanhk05">
                  <e.icon className="h-7 w-7" strokeWidth={1.8} data-id="element-449" data-mp="1tn5ms9fqjx83" />
                </div>
                <h3 className="mt-6 font-display text-lg font-bold text-navy" data-id="element-450" data-mp="1tpiehebaplyc">
                  {e.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-451" data-mp="1kn0rgxntgpaa">
                  {e.text}
                </p>
              </div>
            </Reveal>)}
        </div>
        <Reveal className="mt-12 flex justify-center" data-id="element-452" data-mp="2db4xjkaav4di">
          <MagneticButton variant="primary" to="/contact" data-id="element-453" data-mp="2dboil9v8y8vr">
            Request Non-Emergency Help
          </MagneticButton>
        </Reveal>
      </section>

      <ProcessSection data-id="element-454" data-mp="23lli6olspsne" />
    </>;
}